// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import model_1 from '/root/src/models/useCampaign';
import model_2 from '/root/src/models/useCompany';
import model_3 from '/root/src/models/useConversion';
import model_4 from '/root/src/models/useInsights';
import model_5 from '/root/src/models/usePerformance';
import model_6 from '/root/src/models/useProduct';
import model_7 from '/root/src/models/useRevenue';
import model_8 from '/root/src/models/useTracking';
import model_9 from '/root/src/models/useTrafficQuality';
import model_11 from '/root/src/.umi-production/plugin-initialState/@@initialState';
import model_10 from '/root/src/models/useUser';

export const models = {
model_1: { namespace: 'useCampaign', model: model_1 },
model_2: { namespace: 'useCompany', model: model_2 },
model_3: { namespace: 'useConversion', model: model_3 },
model_4: { namespace: 'useInsights', model: model_4 },
model_5: { namespace: 'usePerformance', model: model_5 },
model_6: { namespace: 'useProduct', model: model_6 },
model_7: { namespace: 'useRevenue', model: model_7 },
model_8: { namespace: 'useTracking', model: model_8 },
model_9: { namespace: 'useTrafficQuality', model: model_9 },
model_11: { namespace: '@@initialState', model: model_11 },
model_10: { namespace: 'useUser', model: model_10 },
} as const
